export const PROJECT_TITLE_FIELD = 'title'

export const getDefaultValues = () => ({
  [PROJECT_TITLE_FIELD]: '',
})
